import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { DiscountService } from './discount.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { AppMainComponent } from 'src/app/app.main.component';
import { SetupService } from '../setup.service';
import { ObjectNames, Status, Severity, Answer } from '../../constants/constants';
import { DiscountModuleEnum, discountSectionOptions  } from './discount.module.enum';


@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.scss']
})
export class DiscountComponent implements OnInit, OnChanges, OnDestroy {

  @Input() financialAccounts: any[] = [];
  @Input() baseCurrency: any;
  @Input() groups: any[] = [];
  @Input() discountBy: any[] = [];

  isAddDiscount: boolean = false;
  discountForm: FormGroup;
  allDiscounts: any[] = [];
  addEditDiscountHeader: string;
  displayDiscountAdd: boolean = false;
  minimumDate = new Date(1900, 0, 1);
  allLimitations: any[] = [];
  expenseAccountList: any[] = [];
  incomeAccountList: any[] = [];

  statusConstants = Status;
  answertypeConstants = Answer;
  discountConstantsProperty = ObjectNames.setupConstants;
  enable: boolean = false;
  isSystem: boolean = false;
  isDuplicacy: boolean = false;
  discountTypes = [
    { id: 1, name: "Assigned to order total" },
    { id: 2, name: "Assigned to shipping" },
    { id: 3, name: "Assigned to order subtotal" },
  ];
  discountModuleTypes: any = DiscountModuleEnum;
  discountModuleTypesArray : any = [];
  discountSectionOptions : any = discountSectionOptions ;
  selectedDiscount: any;

  constructor(private fb: FormBuilder, private discountService: DiscountService, private confirmationService: ConfirmationService,
    private messageService: MessageService, private titlecasePipe: TitleCasePipe, private datePipe: DatePipe,
    private app: AppMainComponent, private setupService: SetupService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.financialAccounts?.currentValue) {
      for (let parent of this.financialAccounts) {
        parent.selectable = false;
        for (let child of parent.children) {
          child.selectable = true;
          for (let subChild of child.children) {
            subChild.selectable = true;
          }
        }
      }
    }
    if(changes?.discountBy?.currentValue){
      this.discountBy = changes?.discountBy?.currentValue;
    }
  }

  ngOnInit(): void {
    this.setupService.getDiscount().subscribe(discount => {
      if (discount) {
        this.showAddDiscount();
      }
    })
    this.getDiscountGroup();
    this.discountForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: [''],
      organizationId: [''],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      discountBy: [this.discountBy[0]],
      discountValue: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      isCoupanCode: [false],
      coupanCode: [''],
      isCumulative: [false],
      limitationId: [0],
      limitationValue: [''],
      incomeAccount: [0, [Validators.required]],
      expenseAccount: [0],
      isTaxable: [true],
      statusId: [true],
      isValid: [true],
      validFromDate: [''],
      validToDate: [''],
      discountModuleId: [''],
      discountCategoryId: [null, [Validators.required]],
    });
    this.loadDiscountList();
    this.convertDiscountModuleTypes();
  }

  getDiscountGroup() {
    // this.discountService.getAllGroups().subscribe((groups) => {
    //   const discountGroup = groups.filter(group => group.name == 'DiscountType')[0];
    //   this.getAllDiscountTypes(discountGroup.id);
    //   const limitationGroup = groups.filter(group => group.name == 'Limitation Types')[0];
    //   this.getAllLimitationTypes(limitationGroup.id);
    // })

    const limitationGroup = this.groups.filter(group => group.name == ObjectNames.setupConstants.Limitation_Name)[0];
    this.getAllLimitationTypes(limitationGroup.id);

  }

  getAllLimitationTypes(id) {
    this.discountService.getAllLimitationTypes(id).subscribe((types) => {
      this.allLimitations = types;
      this.discountForm.controls['limitationId'].setValue(this.allLimitations[0]);
    })
  }

  loadDiscountList(status?) {
    this.discountService.getSetDiscountConfig(status).subscribe((discounts) => {
      this.enable = discounts.item1;
      this.allDiscounts = discounts.item2;
    })
  }

  convertDiscountModuleTypes(){
    this.discountModuleTypesArray = Object.keys(DiscountModuleEnum)
    .filter(key => !isNaN(Number(key)))
    .map(key => ({
      label: DiscountModuleEnum[key],
      value: Number(key)
    }));
  }

  showAddDiscount() {
    this.addEditDiscountHeader = ObjectNames.setupConstants.AddDiscountTitle;
    this.minimumDate = new Date();
    this.isAddDiscount = true;
    this.isSystem = false;
    this.displayDiscountAdd = true;
    this.discountForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      discountBy: [this.discountBy[0]],
      discountValue: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      isCoupanCode: [false],
      coupanCode: [''],
      isCumulative: [false],
      limitationId: [0],
      limitationValue: [''],
      incomeAccount: [this.getIncomeAccount(), [Validators.required]],
      expenseAccount: [0],
      isTaxable: [false],
      statusId: [true],
      isValid: [true],
      validFromDate: [new Date()],
      validToDate: [null],
      discountModuleId: [''],
      discountCategoryId: [null, [Validators.required]],
    });
  }

  getIncomeAccount() {
    const incomeAccount = this.financialAccounts?.filter(acc => acc.labelName == ObjectNames.setupConstants.incomeAccount)[0];
    return (incomeAccount.children?.filter(child => child.labelName == ObjectNames.setupConstants.incomeAccount)[0]);
  }

  showEditDiscount(discount) {
    this.minimumDate = new Date(1900, 0, 1);// minimumDate handeld in onMinimumDate( function
    this.selectedDiscount = discount;
    this.addEditDiscountHeader = ObjectNames.setupConstants.EditDiscountTitle;
    this.displayDiscountAdd = true;
    this.isAddDiscount = false;
    this.isSystem = false;
    discount.validFromDate = new Date(this.datePipe.transform(discount.validFromDate, 'MM/dd/yyyy'));
    if (discount.validToDate) {
      discount.validToDate = new Date(this.datePipe.transform(discount.validToDate, 'MM/dd/yyyy'));
    }
    if (discount.createdSource == 'System') {
      this.isSystem = true;
    }
    this.discountForm.patchValue(discount);
    this.discountForm.controls['statusId'].setValue(discount.statusId == Status.ACTIVE ? true : false);
    const filteredDiscountType = this.discountBy.filter(type => type.id == discount.discountBy)[0];
    this.discountForm.controls['discountBy'].setValue(filteredDiscountType);
    const filteredLimitationType = this.allLimitations.filter(limit => limit.id == discount.limitationId)[0];
    this.discountForm.controls['limitationId'].setValue(filteredLimitationType);
    // const filteredFinancAccount = this.financialAccounts.filter(finance => finance.id == discount.incomeAccount)[0];
    // this.discountForm.controls['incomeAccount'].setValue(filteredFinancAccount);

    //For Parent Financial Account
    const filteredFinancialId = this.financialAccounts?.filter(finance => finance.value?.id == discount.incomeAccount)[0];
    this.discountForm.controls['incomeAccount'].setValue(filteredFinancialId);
    //For Child Financial Account
    this.financialAccounts.forEach(finance => {
      const childAccount = finance.children?.filter(
        (child) => child.value?.id == discount.incomeAccount
      )[0];
      if (childAccount) {
        this.discountForm.controls['incomeAccount'].setValue(childAccount);
      }
    });
    //For Sub-Child Financial Account
    this.financialAccounts.forEach(finance => {
      finance.children?.forEach(element => {
        const subChildAccount = element.children?.filter(
          (child) => child.value?.id == discount.incomeAccount
        )[0];
        if (subChildAccount) {
          this.discountForm.controls['incomeAccount'].setValue(subChildAccount);
        }
      });
    });
    //For forth level Financial Account
    this.financialAccounts.forEach(finance => {
      finance.children?.forEach(fnc => {
        fnc.children?.forEach(element => {
          const forthLevelChildAccount = element.children?.filter(
            (child) => child.value?.id == discount.incomeAccount
          )[0];
          if (forthLevelChildAccount) {
            this.discountForm.controls['incomeAccount'].setValue(forthLevelChildAccount);
          }
        });
      });
    });
  }

  checkDeleteStatus(discount) {
    this.setupService.checkDeleteStatus(discount.id, 'discount').subscribe(check => {
      if (!check.item1) {
        this.deleteDiscount(discount);
      } else {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
      }
    })
  }

  checkUpdateStatus(discount) {
    if(discount.discountModuleId !== this.selectedDiscount?.discountModuleId){
      this.setupService.checkDeleteStatus(discount.id, 'discount').subscribe(check => {
        if (!check.item1) {
          this.saveDiscount(discount);
        } else {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `Can't change the Discount module. ${check.item2}` });
        }
      })
    }else{
      this.saveDiscount(discount);
    }
  }

  deleteDiscount(discount) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Discount?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.discountService.deleteDiscount(discount.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.allDiscounts.indexOf(discount);
          this.allDiscounts.splice(index, 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  setValidators() {
    if (this.discountForm.controls['isCoupanCode'].value) {
      this.discountForm.controls['coupanCode'].setValidators(Validators.required);
    } else {
      this.discountForm.controls['coupanCode'].clearValidators();
      this.discountForm.get('coupanCode').updateValueAndValidity();
    }
  }

  setValidation() {
    if (this.discountForm.controls['limitationId'].value && (this.discountForm.controls['limitationId'].value.name == this.allLimitations[1].name || this.discountForm.controls['limitationId'].value.name == this.allLimitations[2].name)) {
      this.discountForm.controls['limitationValue'].setValidators(Validators.required);
    } else {
      this.discountForm.controls['limitationValue'].clearValidators();
      this.discountForm.get('limitationValue').updateValueAndValidity();
    }
  }
  
  validateDiscountName(value): boolean {
    if (!value?.name?.trim()) {
      return false;
    }
    this.isDuplicacy = this.allDiscounts?.some((ele) => ele.name?.toLowerCase() === value.name.toLowerCase() && ele.id !== value.id);
    return this.isDuplicacy; 
  }

  saveDiscount(value) {
    value.statusId = (value.statusId == true ? Status.ACTIVE : Status.INACTIVE);
    value.discountBy = value.discountBy.id;
    value.incomeAccount = (value.incomeAccount ? value.incomeAccount?.value?.id : 0);
    value.discountEnabled = true;
    if (value.limitationId && value.limitationId.name == ObjectNames.setupConstants.Limit[0]) {
      value.limitationValue = '';
    }
    value.limitationId = (value.limitationId && value.limitationId.id);
    value.description = value.name;
    value.isTaxable = this.discountForm.get('discountCategoryId').value !== 2 && value.isTaxable;
    if (!value.isCoupanCode) {
      value.coupanCode = '';
    }
    const isDuplicacy = this.validateDiscountName(value);
    if (this.isAddDiscount && !isDuplicacy) {
      this.discountService.addDiscount(value).then(() => {
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Discount Added successfully...' });
        this.loadDiscountList();
        this.displayDiscountAdd = false;
      }).catch(() => {
        this.displayDiscountAdd = false;
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
      });
    } else if(!isDuplicacy) {
      value.updatedBy = this.app.userId;
      value.updatedDate = new Date().toISOString();
      value.updatedSource = this.app.userIP;
      this.discountService.updateDiscount(value).then(() => {
        this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Discount Updated successfully...' });
        this.loadDiscountList();
        this.displayDiscountAdd = false;
      }).catch(() => {
        this.displayDiscountAdd = false;
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
      });
    }

  }
  onCancel() {
    this.minimumDate = new Date(1900, 0, 1); 
    this.displayDiscountAdd = false;
    this.isDuplicacy = false;
  }
  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
  //handled minimum date for start date and end date
  onMinimumDate() {
    const selectedDate = this.selectedDiscount?.validFromDate;
    if (this.isAddDiscount) {
      this.minimumDate = new Date();
    } else if (selectedDate) {
      const d = new Date(selectedDate);
      this.minimumDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }
  }
  ngOnDestroy(): void {
    this.setupService.setDiscount('');
  }


}
